import { registerComponent } from '@gig/magic-common';
import LinkComponent from './link.vue.js';

var Link = registerComponent(LinkComponent);

export { Link };
